import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#616783ff',
      dark: '#303a63',
      500: '#45538aff',
      200: '#45538aa8',
      100: '#45538a57',
      50: '#45538a1a'
    },
    secondary: {
      main: '#f0b800ff',
      dark: '#e47c06ff',
      500: '#e99f00ff',
      200: '#fdc50f7a',
      100: '#fdc50f41'
    },
    background: {
      default: '#F8F9FA',
    },
    success: {
      main: '#34C759',
    },
    error: {
      main: '#FF383C',
    },
   
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 700,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
  
});